var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":_vm.widthModal},model:{value:(_vm.ModalWithActionSlot),callback:function ($$v) {_vm.ModalWithActionSlot=$$v},expression:"ModalWithActionSlot"}},[_c('v-card',{staticClass:"overflow-y-auto pa-5",attrs:{"max-height":_vm.heightCard}},[_vm._t("card")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }